function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useRef, useEffect, useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { BodyText } from '@keen.io/typography';
import { Dropdown, DropableContainer, MousePositionedTooltip, RelativeTime, AbsoluteTime, Timezone, TimezoneError, TitleComponent, convertRelativeTime, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { useKeypress } from '@keen.io/react-hooks';
import { AbsoluteTimeLabel, RelativeTimeLabel, Navigation, TimezoneLoader } from './components';
import { Container, ErrorContainer, SettingsContainer } from './Timeframe.styles';
import { AppContext } from '../../contexts';
import { getTimezoneValue } from './utils';
import { getEventPath } from '../../utils';
import { getTimezoneState } from '../../modules/timezone';

var Timeframe = function Timeframe(_ref) {
  var id = _ref.id,
      onTimeframeChange = _ref.onTimeframeChange,
      onTimezoneChange = _ref.onTimezoneChange,
      onReset = _ref.onReset,
      timezone = _ref.timezone,
      value = _ref.value,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'secondary' : _ref$variant;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(AppContext),
      modalContainer = _useContext.modalContainer;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var containerRef = useRef(null);

  var _useSelector = useSelector(getTimezoneState),
      timezones = _useSelector.timezones,
      isLoading = _useSelector.isLoading,
      error = _useSelector.error,
      defaultTimezone = _useSelector.defaultTimezoneForQuery,
      timezoneSelectionDisabled = _useSelector.timezoneSelectionDisabled;

  useEffect(function () {
    return function () {
      if (onReset) onReset();
    };
  }, []);
  var timezoneValue = getTimezoneValue({
    timezone: timezone,
    timezones: timezones,
    isLoading: isLoading,
    defaultTimezone: defaultTimezone
  });
  var keyboardHandler = useCallback(function (_e, keyCode) {
    if (keyCode === KEYBOARD_KEYS.ESCAPE) {
      setOpen(false);
    }
  }, []);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ESCAPE],
    addEventListenerCondition: isOpen,
    eventListenerDependencies: [isOpen]
  });
  return React.createElement(Container, {
    ref: containerRef
  }, React.createElement(TitleComponent, {
    onClick: function onClick() {
      return !isOpen && setOpen(true);
    }
  }, t('query_creator_timeframe.label')), React.createElement(DropableContainer, {
    variant: variant,
    onClick: function onClick() {
      return !isOpen && setOpen(true);
    },
    isActive: isOpen,
    value: value,
    dropIndicator: true,
    onDefocus: function onDefocus(event) {
      var path = getEventPath(event);

      if (!(path === null || path === void 0 ? void 0 : path.includes(containerRef.current))) {
        setOpen(false);
      }
    }
  }, typeof value === 'string' ? React.createElement(RelativeTimeLabel, Object.assign({}, convertRelativeTime(value))) : React.createElement(AbsoluteTimeLabel, {
    start: value.start,
    end: value.end
  })), React.createElement(Dropdown, {
    isOpen: isOpen
  }, React.createElement(Navigation, {
    timeframe: value,
    isDisabled: isLoading || error,
    onTimeframeChange: onTimeframeChange
  }), React.createElement(SettingsContainer, null, typeof value === 'string' ? React.createElement(RelativeTime, Object.assign({
    onChange: onTimeframeChange,
    timeLabel: t('query_creator_relative_time.time_label'),
    unitsPlaceholderLabel: t('query_creator_relative_time.units_placeholder'),
    relativityTitleForTodayLabel: t('query_creator_relative_time.relativity_title_for_today'),
    relativityTitleLabel: t('query_creator_relative_time.relativity_title')
  }, convertRelativeTime(value))) : React.createElement(AbsoluteTime, Object.assign({
    id: id
  }, value, {
    timezone: timezoneValue,
    onChange: onTimeframeChange,
    startDateLabel: t('absolute_time.start_date'),
    endDateLabel: t('absolute_time.end_date')
  }))), isLoading ? React.createElement(TimezoneLoader, {
    message: t('query_creator_timezone.loading')
  }) : React.createElement(React.Fragment, null, error ? React.createElement(ErrorContainer, null, React.createElement(TimezoneError, {
    tooltipPortal: modalContainer,
    tooltipMessage: t('query_creator_timezone.error'),
    placeholder: t('query_creator_timezone.placeholder'),
    label: t('query_creator_timezone.label')
  })) : React.createElement(MousePositionedTooltip, {
    renderContent: function renderContent() {
      return React.createElement(BodyText, {
        variant: "body3",
        fontWeight: "normal"
      }, t('query_creator_timezone.selection_disabled_description'));
    },
    isActive: timezoneSelectionDisabled,
    tooltipPortal: modalContainer
  }, React.createElement(Timezone, {
    timezone: timezoneValue,
    timezones: timezones,
    onChange: function onChange(timezone) {
      return onTimezoneChange(timezone);
    },
    timezoneLabel: t('query_creator_timezone.label'),
    disableSelection: timezoneSelectionDisabled,
    emptySearchLabel: t('query_creator_timezone.empty_search'),
    timezonePlaceholderLabel: t('query_creator_timezone.placeholder')
  })))));
};

export default Timeframe;